export default __webpack_public_path__ + "static/media/Capim_Branco.6cb3ef24.webp";